import { connect } from 'react-redux';

import Investments from './Investments';
import { AccountState } from 'store/features/account/types';
import { RootState } from 'store/types';

const checkFormValidity = ({ account }: { account: AccountState }) => {
  const { firstname, lastname, phone, email, investment } = account;
  return !firstname || !lastname || !phone || !email || !investment || (investment === 0);
};

const mapStateToProps = (state: RootState) => ({
  value: state.account.investment,
  isSubmittable: checkFormValidity(state),
  isConnected: state.roles.isConnected,
  simulation: {
    stockPrice: state.investments.stockPrice,
    valuation: state.investments.valuation,
    taxRate: state.investments.taxRate,
    minAmount: state.investments.minAmount,
    minPeaAmount: state.investments.minPeaAmount || 10000,
    amount: state.investments.amount,
    amountSought: state.investments.amountSought,
  },
  loading: state.account.loading,
  domain: state.investments.domain,
  status: state.investments.status,
  account: state.account,
  calendar: state.investments.inChargeCalendar,
});

export default connect(mapStateToProps)(Investments);
